import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {applyMiddleware, createStore} from "redux";
import {mainReducer} from "./redux/mainReducer";
import {Provider} from "react-redux";
import thunk from "redux-thunk";
import {BrowserRouter, Route, Routes} from "react-router-dom";

const store = createStore(mainReducer, applyMiddleware(thunk))
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.Fragment>
        <Provider store={store}>
            <BrowserRouter>
                <Routes>

                    <Route path="/ru/" element={<App/>}/>
                    <Route path="/" element={<App/>}/>
                </Routes>
            </BrowserRouter>
        </Provider>
    </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
